import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { S3 } from '@aws-sdk/client-s3';
function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
var fetchHyhoContent = function fetchHyhoContent(_ref) {
  var config = _ref.config,
    uri = _ref.uri,
    reporter = _ref.reporter;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var bucketName, bucketLocation, awsAccessKeyId, awsAccessKey, logger, s3params, s3, _yield$s3$getObject, Body, _JSON$parse, body, validFrom, validTo, versionId, documentType;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            bucketName = config.bucketName, bucketLocation = config.bucketLocation, awsAccessKeyId = config.awsAccessKeyId, awsAccessKey = config.awsAccessKey;
            logger = reporter !== null && reporter !== void 0 ? reporter : console;
            s3params = {
              Bucket: bucketName,
              Key: uri
            };
            s3 = new S3({
              region: bucketLocation,
              credentials: {
                accessKeyId: awsAccessKeyId,
                secretAccessKey: awsAccessKey
              }
            });
            _context.prev = 4;
            _context.next = 7;
            return s3.getObject(s3params);
          case 7:
            _yield$s3$getObject = _context.sent;
            Body = _yield$s3$getObject.Body;
            _context.t0 = JSON;
            _context.next = 12;
            return Body === null || Body === void 0 ? void 0 : Body.transformToString('utf-8');
          case 12:
            _context.t1 = _context.sent;
            if (_context.t1) {
              _context.next = 15;
              break;
            }
            _context.t1 = '{}';
          case 15:
            _context.t2 = _context.t1;
            _JSON$parse = _context.t0.parse.call(_context.t0, _context.t2);
            body = _JSON$parse.Content__c;
            validFrom = _JSON$parse.ValidFrom__c;
            validTo = _JSON$parse.ValidTo__c;
            versionId = _JSON$parse.Document_Version_ID__c;
            documentType = _JSON$parse.DocType__c;
            return _context.abrupt("return", {
              body: body,
              validFrom: validFrom,
              validTo: validTo,
              versionId: versionId,
              documentType: documentType
            });
          case 25:
            _context.prev = 25;
            _context.t3 = _context["catch"](4);
            logger.error('Error on fetch hyho content', _context.t3);
            return _context.abrupt("return", null);
          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 25]]);
  }));
};
var LdsHyhoContentFetcher = {
  hyho: function hyho(_a) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var args;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              args = __rest(_a, []);
              return _context2.abrupt("return", fetchHyhoContent(Object.assign({}, args)));
            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  }
};
export { LdsHyhoContentFetcher };